module.exports = __webpack_public_path__ + "static/media/contact_info.0028b1b9.jpg";